import { GET_FILTER_SELECTED_PIDS } from "../../../enums/Employees/employees.types";

export const getFilterSelectedPidsAction = (pids) => {
    return {
        type: GET_FILTER_SELECTED_PIDS,
        payload: pids,
    };
};